import React from 'react';
import { ResultList } from '../../helpers/uiComponents/ResultList';
import { SearchForm } from '../../helpers/uiComponents/Search';

class NfaExplorer extends React.Component {
    render() {
        return(
            <div className="column left-column" id="list-column">
                <section className="section">
                    <h3>Search Retailers: {this.props.data.dealers.length}</h3>
                    <SearchForm page="nfa" />
                </section>
                <ResultList
                    page={"nfa"}
                    data={this.props.data.dealers}
                    load={this.props.load}
					resetProfile={this.props.resetProfile}
                />
            </div>
        )
    }
}
export default NfaExplorer;


// WEBPACK FOOTER //
// ./src/component_nfa/NfaExplorer/Explorer.js